const API_URL =
  import.meta.env.MODE === "development"
    ? "http://localhost:8080"
    : import.meta.env.VITE_API_URL;

async function registerUser(email, password) {
  try {
    const res = await fetch(`${API_URL}/api/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    if (res.status === 409) {
      console.log("Account already exists");
      return false;
    }

    return true;
  } catch (e) {
    console.log(e);
    return null;
  }
}

async function resendCode(email) {
  try {
    const res = await fetch(`${API_URL}/api/code/resend`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.error || "Registration failed");
    }

    const data = await res.json();
    return data.message;
  } catch (e) {
    console.log(e);
  }
}

async function verifyUser(email, code) {
  try {
    const res = await fetch(`${API_URL}/api/code/verify`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, code }),
    });

    if (!res.ok) {
      console.log(res);
      return false;
    }

    return true;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export { registerUser, resendCode, verifyUser };
